import getPriorityForStatus from './getPriorityForStatus';

export default function addObjectPriority(object, hoveredId, selectedId) {
  if (hoveredId && object.id === hoveredId) {
    return {
      ...object,
      priority: 20,
    };
  }

  if (selectedId && object.id === selectedId) {
    return {
      ...object,
      priority: 10,
    };
  }

  return {
    ...object,
    priority: getPriorityForStatus(object.status),
  };
}



// WEBPACK FOOTER //
// ./src/helpers/addObjectPriority.js